// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__RLuRh","tab_item":"tabs_tab_item__ZboEV"};